// The message an API refusal carries, or a generic one when there is none (network, timeout).
// Only its first line: a server in debug mode appends a stack trace after it.
export const errorMessage = (error) =>
  String(error?.response?.data?.message || '').split('\n')[0] || 'Não foi possível concluir a operação. Tente novamente.'
